import { call, fork, put, take } from 'redux-saga/effects'

import { buildHeaders } from '../lib/buildHeaders'
import { addNotification, removeNotification } from '../notifications/notifications-actions'
import { buildBody, getClaimInfo } from './api-claim'
import { claimError, claimSuccess } from './claim-actions'
import { CLAIM_REQUESTING, MAINTENANCE_MESSAGE } from './claim-constants'
import { ClaimDetailsType, FetchClaimArgs } from './types'

function* claimInfo({ claimNumber, dateOfLoss, recaptchaToken }: FetchClaimArgs): Generator<any> {
  try {
    const headers = buildHeaders({
      recaptchaToken: recaptchaToken,
      'Content-Type': 'application/json'
    })
    // On subsequent calls, remove any existing notification
    yield put(removeNotification('claimError'))
    const body = buildBody({ claimNumber, dateOfLoss })
    const claimDetails: ClaimDetailsType = yield call(getClaimInfo, headers, body)

    if (claimDetails && !claimDetails.isValid)
      throw claimDetails

    yield put(claimSuccess(claimDetails))
  } catch(error: any) {
    if (error.status > 5) {
      yield put(claimError({ message: MAINTENANCE_MESSAGE }))
      return
    }

    if (error.message) {
      yield put(claimError())
      yield put(addNotification({
        name: 'claimError',
        body: error.message,
        severity: 'warning',
        title: 'NO MATCH FOUND'
      }))
    }
  }
  return {}
}

function* verifyClaimInfoWatcher() {
  while(true) {
    const { claimNumber, dateOfLoss, recaptchaToken } = yield take(CLAIM_REQUESTING)

    yield fork(claimInfo, { claimNumber, dateOfLoss, recaptchaToken })
  }
}

export {
  claimInfo,
  verifyClaimInfoWatcher
}
